export default __webpack_public_path__ + "static/media/cchat-logo-transparent-dark.73fa7692.png";